import { render, staticRenderFns } from "./PrivacyPolicyApp.vue?vue&type=template&id=739fbe64&"
import script from "./PrivacyPolicyApp.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyApp.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyApp.vue?vue&type=style&index=0&id=739fbe64&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports